

function scrollToElement(id) {
    const element = document.getElementById(id);
    if (element)
    {
        //const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        //const offsetPosition = elementPosition - 300;

        //window.scrollTo({
        //    top: offsetPosition,
        //    behavior: 'smooth'
        //});

        // Focus the element after scrolling to it
        element.focus();
    }
}

window.a11y = {
    setFocusToElement: (elementId) =>
    {

        var element = document.getElementById(elementId);
        if (element)
        {
            element.focus();
        }
    },
    getClientWidth: () =>
    {
        return window.innerWidth;
    },

    registerResizeCallback: (dotNetObject) =>
    {

        window.addEventListener('resize', () =>
        {
            dotNetObject.invokeMethodAsync('OnResize', window.innerWidth);
        });
    },

    scrollToAndFocus: (elementId) =>
    {
        if (!elementId) return;

        const element = document.getElementById(elementId);
        if (!element) return;

        element.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Ensure focusable
        if (!element.hasAttribute('tabindex'))
        {
            element.setAttribute('tabindex', '-1');
        }

        // Wait for scroll to settle a bit
        window.setTimeout(() => element.focus(), 250);
    },

    scrollToSelectorAndFocus: (selector) =>
    {
        if (!selector) return;

        const element = document.querySelector(selector);
        if (!element) return;

        element.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (!element.hasAttribute('tabindex'))
        {
            element.setAttribute('tabindex', '-1');
        }

        window.setTimeout(() => element.focus(), 250);
    }

}

window.registerBackButtonHandler = (dotNetHelper) =>
{
    window.addEventListener('popstate', () =>
    {
        // Let Blazor handle the navigation first, then cleanup modal artifacts.
        // Doing heavy DOM work during popstate can break interactivity.
        window.setTimeout(() =>
        {
            try
            {
                dotNetHelper.invokeMethodAsync('OnBrowserBack');
            }
            catch { }

            if (window.bootstrapModalCleanup)
            {
                const fn = window.bootstrapModalCleanup.closeAllModalsAfterNavigation || window.bootstrapModalCleanup.closeAllModals;
                if (typeof fn === 'function')
                {
                    fn();
                    return;
                }
            }

            // Fallback (legacy)
            document.body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '';

            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop)
            {
                backdrop.remove();
            }
        }, 0);
    });
};

window.focusToast = function ()
{
    var toast = document.querySelector('.toast.show, .bb-toast.show');
    if (toast)
    {
        toast.setAttribute('tabindex', '-1');
        toast.focus();
    }
};
